// eslint-disable-next-line import/no-extraneous-dependencies
import React from 'react';
import { ChecklistDescriptionWrapper } from './styled';
import AnimateHeight from 'react-animate-height';

const ANIMATION_DURATION = 200;

type Props = {
	children?: JSX.Element;
	expanded: boolean;
};

export default ({ children, expanded }: Props) => (
	<AnimateHeight duration={ANIMATION_DURATION} easing="ease" height={expanded ? 'auto' : 0}>
		<ChecklistDescriptionWrapper>{children}</ChecklistDescriptionWrapper>
	</AnimateHeight>
);
